import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Flight, ImageItem } from 'solar-bo';

@Component({
  selector: 'app-img-thumb',
  templateUrl: './img-thumb.component.html',
  styleUrls: ['./img-thumb.component.scss']
})
export class ImgThumbComponent implements OnInit {


  @Input() selectedIndex:number;
  @Input() item:ImageItem;
  @Input() idx:number;
  @Input() options:{showLabels:boolean,clickable:boolean}={showLabels:true,clickable:true};

  @Output()show_event = new EventEmitter();
  @Output()addissue_event = new EventEmitter();
  @Output()expandImage_event = new EventEmitter();
  //@Output() onThumbRightClick: EventEmitter<{ gallery: any, imgDTO: ImageItem }> = new EventEmitter<{ gallery: any, imgDTO: ImageItem }>();


  showtoolbar=false;
  constructor() { }

  ngOnInit(): void {
  }

    /**
   * Show tooltip on image
   * @param imageItem 
   */
  imageDescriptionToolTip(imageItem: ImageItem) {
    try{
      let flight: Flight = imageItem.tag.flight;
      let img: any = imageItem.tag.image;
      return "Flight: " + flight.name + " Img: " + imageItem.label + " Time:" + img.time;
    }
    catch(err){
      return "";
    }

  }


  show_click(){
    this.show_event.next(this.item);
  }
  addissue_click(){
    this.addissue_event.next(this.item);
  }
  expandImage_click(){
    this.expandImage_event.next(this.item);
  }
}
